import { render, staticRenderFns } from "./menu-tertiary.vue?vue&type=template&id=246b3870&scoped=true"
import script from "./menu-tertiary.vue?vue&type=script&lang=js"
export * from "./menu-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b3870",
  null
  
)

export default component.exports